import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import KeyEventCard from "./KeyEventCard";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";

interface KeyEvent {
  id: number;
  title: string;
  image: string;
  category: string;
}

interface KeyEventDisplayProps {
  filteredEvents: KeyEvent[];
  isMobile: boolean;
  onOpenForm?: () => void;
  slideDirection?: "left" | "right";
  activeCategory?: string;
}

const KeyEventDisplay = ({
  filteredEvents,
  isMobile,
  onOpenForm,
  slideDirection = "right",
  activeCategory = "",
}: KeyEventDisplayProps) => {
  // Mobile: carousel
  if (isMobile) {
    return (
      <Carousel className="w-full">
        <CarouselContent className="-ml-2">
          {filteredEvents.map(event => (
            <CarouselItem key={event.id} className="pl-2 basis-[75%]">
              <KeyEventCard event={event} onOpenForm={onOpenForm} />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    );
  }

  // Desktop: animated grid of 4 cards
  const slideVariants = {
    enter: (direction: "left" | "right") => ({
      x: direction === "right" ? "100%" : "-100%",
    }),
    center: {
      x: 0,
    },
    exit: (direction: "left" | "right") => ({
      x: direction === "right" ? "-100%" : "100%",
    }),
  };

  return (
    <div className="w-full overflow-hidden relative">
      <AnimatePresence mode="popLayout" custom={slideDirection} initial={false}>
        <motion.div
          key={activeCategory}
          custom={slideDirection}
          variants={slideVariants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            x: { duration: 0.3, ease: "easeInOut" },
          }}
          className="grid grid-cols-4 gap-6"
        >
          {filteredEvents.map(event => (
            <KeyEventCard key={event.id} event={event} onOpenForm={onOpenForm} />
          ))}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default KeyEventDisplay;
